export const RuntimeEnv = {
  runtime: import.meta.env.RUNTIME_ENV || 'prod',
  buildTMS: import.meta.env.BUILD_TIMESTAMP || '',
}
